import disableBrowserBackButton from 'disable-browser-back-navigation';
import 'jquery/dist/jquery';
import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { Scrollbars } from 'react-custom-scrollbars';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import IdleTimer from 'react-idle-timer'; // For Idle
import { withRouter } from "react-router-dom";
import Spinner from 'react-spinner-material'; //Import Spinner
import { basicAuth } from './basicAuth';
import './css/react-confirm-alert.css'; // Import css
import './css/style-responsive.css';
import './css/style.css';
import './css/FileUpload.css';
import { decryptData, Encrypt } from './Encryption-Decrypytion';
import { showAlert, showSuccess } from './services/ConfirmAlert';
import FormDataService from './services';
import { fetchApi, generateChecksumWithKeyNew } from './services/checksum';
import { appConfig } from "./appConfig";

class taskactive extends Component {
  state = {
    TaskDropdwn: false,
    hasError: false
  }
  showTaskDropdwnHandler = () => {
    this.setState({
      TaskDropdwn: !(this.state.TaskDropdwn)
    })
  }

  componentDidMount() {
    if (window.innerWidth <= 768) { this.setState({ hammenu: false }) }
  }



  constructor(props) {
    super(props);
    this.state = {
      displayMenu: false,
      hasError: false   //Added by chandrani for custom error page
    };
    this.state = {
      fileData:"",
      stringData:"",
      roleId:"",
      selectedOption:"",
      dateStatus:null,
      energyAuditFile:null,
      deepCleaningFile:null,
      pestControlFile:null,
      storeConnectFile:null,
      workFile:null,
      cmFile: null,
      pmFile: null,
      cmPreview: null,
      pmPreview: null,
      permitWorkPreview:null,
      energyAuditPreview:null,
      deepCleaningPreview:null,
      pestControlPreview:null,
      storeConnectPreview:null,
      previewImage: null,
      selectedFile: null,
      uploadSuccess: false,
      uploadError: null,
      showFileInput: false,
      showManualUploadOptions: false,
     // instructionUpload: "",
     // previewState: false,
      //instructiondata: [],
      startDatee:new Date(),
      previewImage: null,
      selectedFile: null,
      uploadSuccess: false,
      uploadError: null,
     // instructionUpload: "",
     // previewState: false,
      //instructiondata: [],
      startDate: "",
      endDate: "",
      resptaskname: [],
      respstartdate: [],
      respenddate: [],
      resptaskdesc: [],
      data: [],
      usrnm: "",
      userid: "",
      Search: "",
      searchSDate: "",
      searchedDate: "",
      searcheddesc: "",
      tskId: "",
      tskName: "",
      loading: false,
      hasError: false,   //Added by chandrani for custom error page
      hammenu: true,
      storeNo: "",
      technicianId: "",
      storeManagerStatus: "",
      afmStatus: "",
      role_id: "",
      tickerList: [],
      guId: "",
      categoryName: "",
      categoryId: "",
      zonalStatus: ""
    };
    this.idleTimer = null
    this.onAction = this._onAction.bind(this)
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this)
    this.handleChangeStart = this.handleChangeStart.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
    this.showDropdownMenu = this.showDropdownMenu.bind(this);
    this.hideDropdownMenu = this.hideDropdownMenu.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.toggleManualUploadOptions = this.toggleManualUploadOptions.bind(this);
  }


  logoutnormal = () => {

    localStorage.clear();
    this.props.history.replace('/');
    disableBrowserBackButton();
  }

  handleChangeStart(date) {
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    this.setState({
      searchSDate: (date.getDate() + '-' + monthNames[date.getMonth()] + "-" + date.getFullYear()),
      startDate: date

    });
  }
  handleChangeEnd(date) {
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    this.setState({
      searchedDate: (date.getDate() + '-' + monthNames[date.getMonth()] + "-" + date.getFullYear()),
      endDate: date
    });

    
  }

  handleDateChange(date) {
    this.setState({
      startDatee: date
    });
    console.log("date",date);
  }
  logout = () => {
    var Request1 = {
      "guId": this.props.location.state.guId,
      "userId": this.props.location.state.userid
    }

    // Use fetchApi with encryption and checksum validation (similar to Login and CreateTask APIs)
    fetchApi(appConfig.apiBaseUrl_Login + '/LogOut', {
      method: 'POST',
      headers: {
        guId: this.props.location.state.guId,
        'Authorization': 'Basic ' + basicAuth(this.props.location.state.userid),
      },
      body: Request1
    },)
      // .then((response) => response.text())
      // .then((response) => {
        .then((result) => {
                        
          var DecryptedResponse1 = result.data;
        // var DecryptedResponse1 = decryptData(response);
        if (DecryptedResponse1.responseCode === '200 OK') {

          localStorage.clear();
          this.props.history.replace('/');
          disableBrowserBackButton();

        }
        else {
          this.setState({ loading: false })
          showSuccess(DecryptedResponse1.responseMsg)
        }
      })
      .catch((error) => {
        console.error('========== [Logout API] Error Details ==========');
        console.error('[Logout] Error:', error);
        console.error('[Logout] Error Message:', error.message);
        console.error('========================================================');
        
        confirmAlert({
          title: 'Alert !',
          message: "Session expired",
          buttons: [
            {
              label: 'Ok',
              onClick: () => { this.logoutnormal() }
            },

          ]


        });

      });


  }

  showDropdownMenu(event) {
    event.preventDefault();
    this.setState({ displayMenu: true }, () => {
      document.addEventListener('click', this.hideDropdownMenu);
    });
  }

  hideDropdownMenu() {
    this.setState({ displayMenu: false }, () => {
      document.removeEventListener('click', this.hideDropdownMenu);
    });

  }

  convert = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join("-");
  }

  onChange = e => {
    this.setState({
      Search: e.target.value
    });
  }


  onChange1 = e => {
    this.setState({ searcheddesc: e.target.value });
  }

  showTaskdwnHandler = () => {
    this.setState({
      Taskdwn: !(this.state.Taskdwn)
    })
  }


  handleDateChangeRaws = (e) => {
    e.preventDefault();
  }
  handleDateChangeRawe = (e) => {
    e.preventDefault();
  }

  _onAction(e) {
    //console.log('user did something', e)
  }

  _onActive(e) {
    // console.log('user is active', e)
    //console.log('time remaining', this.idleTimer.getRemainingTime())
  }

  _onIdle(e) {
    localStorage.clear();
    this.props.history.replace('/');
    disableBrowserBackButton();
  }

  componentWillMount() {
    this.GetTasksOnload();

  }


  //Added by chandrani for custom error page
  componentDidCatch() {
    this.setState({ hasError: true })
  }


  handleDownloaddd = () => {
    // Add your download logic here if needed
    this.props.history.push('/TaskReport'); // Change '/NewComponentPath' to your target route
  };

  
//   handleFileChange =(event) => {
//     const selectedFile = event.target.files[0];
//     console.log("a")
//     const previewImage = URL.createObjectURL(selectedFile);
//     console.log("b",selectedFile)

//     this.setState({
//         selectedFile,
//         previewImage,
//         uploadSuccess: false,
//         uploadError: null,
       
//     })
// }


// handleUpload =() => {
//   const {selectedFile} = this.state;
//   const formData = new FormData();
//   formData.append('image',selectedFile);
//   console.log("data",formData)
// }

// handleFileChange =(event) => {
//   const selectedFile = event.target.files[0];
//   const maxFileSize = 1 * 1024 * 1024; 

//   if (selectedFile.size > maxFileSize) {
//     confirmAlert({
//       title: 'Alert!',
//       message: 'File size exceeds the 1 MB limit. Please upload a smaller file.',
//     });
//     this.setState({
//       uploadError: 'File size exceeds the 1 MB limit. Please upload a smaller file.',
//       cmPreview: null,
//       pmPreview: null,
//       auditPreview: null,
//       permitWorkPreview: null,
//       energyAuditPreview: null,
//       deepCleaningPreview: null,
//       pestControlPreview: null,
//       storeConnectPreview: null,
//     });
//     return;
//   }
   
//   const previewImage = URL.createObjectURL(selectedFile);
//   console.log("File to be Selected",selectedFile.name)

//   this.setState({
//     fileData:selectedFile.name, 
//     uploadError: 'File size exceeds the 3 MB limit. Please upload a smaller file.',
//   });

  
//   const reader = new FileReader();

//   reader.onload = (e) => {
//     const arrayBuffer = e.target.result;

   
//     const binaryString = new Uint8Array(arrayBuffer)
//       .reduce((data, byte) => data + String.fromCharCode(byte), '');

    
//     const base64String = btoa(binaryString);

//     console.log("Base64 String:", base64String);
 
//     this.setState({
//       stringData:base64String, 
//     });
//   };
 
//   reader.readAsArrayBuffer(selectedFile);
 
//   if (this.state.selectedOption === 'CM') {
//     this.setState({
//       cmFile: selectedFile,
//       cmPreview: previewImage,
//       uploadSuccess: false,
//       uploadError: null,
//     });
//   } else if (this.state.selectedOption === 'PM') {
//     this.setState({
//       pmFile: selectedFile,
//       pmPreview: previewImage,
//       uploadSuccess: false,
//       uploadError: null,
//     });
//   }
//   else if (this.state.selectedOption === 'StoreAudit') {
//     this.setState({
//       auditFile: selectedFile,
//       auditPreview: previewImage,
//       uploadSuccess: false,
//       uploadError: null,
//     });
//   }
//   else if (this.state.selectedOption === 'PermitToWork') {
//     this.setState({
//       workFile: selectedFile,
//       permitWorkPreview: previewImage,
//       uploadSuccess: false,
//       uploadError: null,
//     });
//   }
//   else if (this.state.selectedOption === 'EnergyAudit') {
//     this.setState({
//       energyAuditFile: selectedFile,
//       energyAuditPreview: previewImage,
//       uploadSuccess: false,
//       uploadError: null,
//     });
//   }
//   else if (this.state.selectedOption === 'DeepCleaning') {
//     this.setState({
//       deepCleaningFile: selectedFile,
//       deepCleaningPreview: previewImage,
//       uploadSuccess: false,
//       uploadError: null,
//     });
//   }
//   else if (this.state.selectedOption === 'PestControl') {
//     this.setState({
//       pestControlFile: selectedFile,
//       pestControlPreview: previewImage,
//       uploadSuccess: false,
//       uploadError: null,
//     });
//   }
//   else if (this.state.selectedOption === 'StoreConnect') {
//     this.setState({
//       storeConnectFile: selectedFile,
//       storeConnectPreview: previewImage,
//       uploadSuccess: false,
//       uploadError: null,
//     });
//   }
  
// }


handleFileChange =(event) => {
  const selectedFile = event.target.files[0];
  this.fileInputRef = event.target;

  this.setState({
    fileData: '',
    stringData: '',
    cmFile: null,
    cmPreview: '',
    pmFile: null,
    pmPreview: '',
    auditFile: null,
    auditPreview: '',
    workFile: null,
    permitWorkPreview: '',
    energyAuditFile: null,
    energyAuditPreview: '',
    deepCleaningFile: null,
    deepCleaningPreview: '',
    pestControlFile: null,
    pestControlPreview: '',
    storeConnectFile: null,
    storeConnectPreview: '',
    uploadSuccess: false,
    uploadError: null,
  });


  if (!selectedFile) {
    // If no file is selected, reset the state or take appropriate action
    this.setState({
      fileData: '',
      stringData: '',
      uploadSuccess: false,
      uploadError: null,
    });
    return;
  }

  const maxFileSize = 1 * 1024 * 1024;
  if (selectedFile.size > maxFileSize) {
    confirmAlert({
      title: 'Alert!',
      message: 'File size exceeds the 1 MB limit. Please upload a smaller file.',
    });
    this.setState({
      uploadError: 'File size exceeds the 1 MB limit. Please upload a smaller file.',
      cmPreview: null,
      pmPreview: null,
      auditPreview: null,
      permitWorkPreview: null,
      energyAuditPreview: null,
      deepCleaningPreview: null,
      pestControlPreview: null,
      storeConnectPreview: null,
    });
    return;
  }

  if (
    selectedFile.type === "application/pdf" ||
    selectedFile.type === "image/jpg" ||
    selectedFile.type === "image/jpeg" ||
    selectedFile.type === "image/png"
  )
  {
   
  const previewImage = URL.createObjectURL(selectedFile);
  console.log("File to be Selected",selectedFile.name)

  this.setState({
    fileData:selectedFile.name, 
  });

  
  const reader = new FileReader();

  reader.onload = (e) => {
    const arrayBuffer = e.target.result;

   
    const binaryString = new Uint8Array(arrayBuffer)
      .reduce((data, byte) => data + String.fromCharCode(byte), '');

    
    const base64String = btoa(binaryString);

    console.log("Base64 String:", base64String);
 
    this.setState({
      stringData:base64String, 
    });
  };
 
  reader.readAsArrayBuffer(selectedFile);
 
  if (this.state.selectedOption === 'CM') {
    this.setState({
      cmFile: selectedFile,
      cmPreview: previewImage,
      uploadSuccess: false,
      uploadError: null,
    });
  } else if (this.state.selectedOption === 'PM') {
    this.setState({
      pmFile: selectedFile,
      pmPreview: previewImage,
      uploadSuccess: false,
      uploadError: null,
    });
  }
  else if (this.state.selectedOption === 'STORE AUDIT') {
    this.setState({
      auditFile: selectedFile,
      auditPreview: previewImage,
      uploadSuccess: false,
      uploadError: null,
    });
  }
  else if (this.state.selectedOption === 'WORK PERMIT') {
    this.setState({
      workFile: selectedFile,
      permitWorkPreview: previewImage,
      uploadSuccess: false,
      uploadError: null,
    });
  }
  else if (this.state.selectedOption === 'ENERGY AUDIT') {
    this.setState({
      energyAuditFile: selectedFile,
      energyAuditPreview: previewImage,
      uploadSuccess: false,
      uploadError: null,
    });
  }
  else if (this.state.selectedOption === 'DEEP CLEANING') {
    this.setState({
      deepCleaningFile: selectedFile,
      deepCleaningPreview: previewImage,
      uploadSuccess: false,
      uploadError: null,
    });
  }
  else if (this.state.selectedOption === 'PEST CONTROL') {
    this.setState({
      pestControlFile: selectedFile,
      pestControlPreview: previewImage,
      uploadSuccess: false,
      uploadError: null,
    });
  }
  else if (this.state.selectedOption === 'STORE CONNECT') {
    this.setState({
      storeConnectFile: selectedFile,
      storeConnectPreview: previewImage,
      uploadSuccess: false,
      uploadError: null,
    });
  }
} else {
  this.setState({
    selectedFile: '',
    previewImage: '',
    uploadSuccess: false,
    uploadError: "Unsupported File Format.",
  });
  confirmAlert({
    // title: 'Confirm to submit',
    message: "Unsupported File Format.",
    buttons: [
      {
        label: "Ok",
        // onClick: () => alert('Click Yes')
      },
    ],
  });
}
  
}




// handleUpload =() => {
//   const {selectedFile} = this.state;
//   const formData = new FormData();
//   formData.append('image',selectedFile);
//   console.log("data",formData)
// }
handleUpload = () => {
const { selectedOption, cmFile, pmFile, auditFile,workFile,energyAuditFile,deepCleaningFile,pestControlFile,storeConnectFile,base64String} = this.state;
//const selectedFile = selectedOption === 'CM' ? cmFile : selectedOption === 'PM' ? pmFile : auditFile;
// const selectedFile = selectedOption === 'CM' ? cmFile : selectedOption === 'PM' ? pmFile : selectedOption === 'StoreAudit' ? auditFile : selectedOption === 'PermitToWork' ? workFile : null;
const selectedFile = selectedOption === 'CM' ? cmFile : 
                       selectedOption === 'PM' ? pmFile : 
                       selectedOption === 'STORE AUDIT' ? auditFile : 
                       selectedOption === 'WORK PERMIT' ? workFile : 
                       selectedOption === 'ENERGY AUDIT' ? energyAuditFile : 
                       selectedOption === 'DEEP CLEANING' ? deepCleaningFile:      
                       selectedOption === 'PEST CONTROL' ? pestControlFile:
                       selectedOption === 'STORE CONNECT' ? storeConnectFile:null;
if (!selectedFile) {
  this.setState({ uploadError: 'No file selected for upload.' });
  return;
}


const formData = new FormData();
formData.append('image', selectedFile);
formData.append("file",selectedFile)
console.log("Uploading", selectedOption, "file:",  formData.get('image'));
console.log("data to check",this.state.stringData);
console.log("name",this.state.fileData);
console.log("data name",selectedFile);
setTimeout(() => {
  this.setState({ uploadSuccess: true, uploadError: null ,uploadedFile: selectedFile});
}, 1000);


// var Request1 = {
//   "userId": this.props.location.state.userid,
//   "date": this.convert(this.state.startDatee),
//   "categoryName": this.state.selectedOption,
//   "roleId": this.props.location.state.role_id,
//   "fileUpload": this.state.stringData,
//   "fileName":this.state.fileData
// }
// var EncryptedRequest1 = Encrypt(Request1);
// fetch('/categoryFileUpload', {
//   //  fetch('/Report/categoryFileUpload', {
//   method: 'POST',
//   body: EncryptedRequest1,
//   headers: {
//     guId: this.props.location.state.guId,
//     'Authorization': 'Basic ' + basicAuth(this.props.location.state.userid),
//   }
// })
//   .then((response) => response.text())
//   .then((response) => {
//     var DecryptedResponse1 = decryptData(response)
//     if (DecryptedResponse1.errorCode === '00') {
//       showSuccess(DecryptedResponse1.errorMsg)
//      console.log("data",DecryptedResponse1.errorMsg)
//     }
//     else {
//       console.log("Failed to Upload the file",DecryptedResponse1.errorMsg);
//     }
//   })
//   .catch((error) => {
//     confirmAlert({
//       title: 'Alert !',
//       message: "Unable to upload File",
//     });
//   });
// };

var Request1 = {
  "userId": this.props.location.state.userid,
  "date": this.convert(this.state.startDatee),
  "categoryName": this.state.selectedOption,
  "roleId": this.props.location.state.role_id,
  "fileUpload": this.state.stringData,
  "fileName":this.state.fileData
}
var EncryptedRequest1 = (JSON.stringify(Request1));
fetch('/categoryFileUpload', {
  //  fetch('/Report/categoryFileUpload', {
  method: 'POST',
  body: EncryptedRequest1,
  headers: {
    guId: this.props.location.state.guId,
    'Authorization': 'Basic ' + basicAuth(this.props.location.state.userid),
  }
})
  .then((response) => response.json())
  
  .then((response) => {
    const DecryptedResponse1 = (response)
    console.log("checkkkk",typeof DecryptedResponse1);
    if ((DecryptedResponse1.errorCode) === "00") {
      showSuccess((response.errorMsg))
     console.log("data",DecryptedResponse1.errorMsg)
    }
    else {
      console.log("Failed to Upload the file",DecryptedResponse1.errorMsg);
    }
  })
  .catch((error) => {
    confirmAlert({
      title: 'Alert !',
      message: "Unable to upload File",
    });
  });
};


handleOptionClick = (option) => {

// if (option === 'CM') {
//   this.state.roleId = '300';
// } else if (option === 'PM') {
//   this.state.roleId = '501';
// } else if (option === 'StoreAudit') {
//   this.state.roleId = '508';
// }


this.setState({
  // selectedOption: option,
  // roleId: this.state.roleId,
  // showFileInput: true,
      selectedOption: option,
      cmPreview: null,
      pmPreview: null,
      auditPreview: null,
      permitWorkPreview: null,
      energyAuditPreview: null,
      deepCleaningPreview: null,
      pestControlPreview: null,
      storeConnectPreview:null,
      showFileInput: true,
      uploadedFile: null,
      uploadSuccess: false,
      uploadError: '',
      fileData: "",
});
if (this.fileInputRef) {
  this.fileInputRef.value = "";
}
};

toggleManualUploadOptions = () => {
this.setState((prevState) => ({
  showManualUploadOptions: !prevState.showManualUploadOptions,
  showFileInput: false,
}));
};

clickHandle = () => {
this.props.history.push('/Upload')
}

handleDownload = () => {
const { uploadedFile } = this.state;

// Ensure that there is an uploaded file
if (!uploadedFile) {
  console.error("No file uploaded for download.");
  return;
}

// Create a temporary URL for the uploaded file
const fileURL = URL.createObjectURL(uploadedFile);

// Create a link element
const downloadLink = document.createElement('a');

// Set the href attribute to the temporary URL
downloadLink.href = fileURL;

// Set the download attribute to the file name
downloadLink.download = uploadedFile.name;

// Append the link element to the document body
document.body.appendChild(downloadLink);

// Click the link to trigger the download
downloadLink.click();

// Clean up: remove the link and revoke the URL
document.body.removeChild(downloadLink);
URL.revokeObjectURL(fileURL);
};


  render = () => {
    
    console.log("roleid",this.props.location.state.role_id);
    console.log("userid",this.props.location.state.userid);
    console.log("Category Name", this.state.selectedOption);
    console.log("date",this.convert(this.state.startDatee));
    console.log("String API",this.state.stringData);
   // console.log("Base64 String:", base64String);
  

    var that = this;

    const { Search } = this.state;
    const { searchSDate } = this.state;
    const { searchedDate } = this.state;
    const { searcheddesc } = this.state;


    const { previewImage,uploadSuccess, uploadError,showFileInput,showManualUploadOptions,cmPreview,permitWorkPreview,
      pmPreview,uploadedFile,auditPreview,energyAuditPreview,deepCleaningPreview,pestControlPreview,storeConnectPreview} = this.state;




    if (this.state.hasError) {
      return (
        <div><h2>Error occurred!! please contact administrator</h2></div>
      )
    } else {

      return (

        <div>
          <section id="container">
            <header className="header black-bg" >

              <div>
                <IdleTimer
                  ref={ref => { this.idleTimer = ref }}
                  element={document}
                  onActive={this.onActive}
                  onIdle={this.onIdle}
                  onAction={this.onAction}
                  debounce={250}
                  timeout={1000 * 60 * 10} />

              </div>

              <a className="mob-show" onClick={() => this.setState({ hammenu: !this.state.hammenu })}><i className="fa fa-tasks hammenu" style={{ "margin-top": "30px" }}></i></a>
              <a onClick={this.TaskactiveBind.bind(this)} className="logo"><img src={require("./img/retail-logo.png")} alt="logo" /></a>
              <div className="markcenter">
                <p className="marquee">{this.state.tickerList}</p>
              </div>
              <ul className="nav pull-right pos-rel">

                <li className="dropdown" ><a className="dropdown-toggle" data-toggle="dropdown" onClick={this.showDropdownMenu}> <img src={require("./img/user.png")} className="user-img" />
                  {this.state.role_id == "506" ?
                    <b>{this.state.usrnm}({this.props.location.state.storeNo})</b> : <b>{this.state.usrnm}</b>}
                  <b className="caret" /></a>
                </li>

                {this.state.displayMenu ?
                  (

                    <ul className="dropdown-menuuser-dd">
                      <li><a onClick={this.Changepasswordbind} >Change Password</a></li>
                      <li className="divider"></li>
                      <li><a onClick={this.logout} >Log Out</a></li>
                    </ul>
                  ) :
                  (
                    null
                  )
                }

              </ul>
            </header>
            <aside>

              <div id="sidebar" className="nav-collapse">
                {this.state.hammenu ?
                  <ul className="sidebar-menu" id="nav-accordion">
                    <li className="sub-menu mt" onClick={this.showTaskDropdwnHandler.bind(this)}> <a href="javascript:;"> <i className="fa fa-tasks"></i> <span>Task</span> </a>
                      {this.state.TaskDropdwn ?
                        <div>
                          <ul class="sub" >
                            {this.state.role_id == "300" ?
                              <>
                                <li><a onClick={this.getroles.bind(this)}>Create Task</a></li>
                                <li><a onClick={this.TaskactiveBind.bind(this)}>Active Task(s)</a></li>
                              </>
                              :
                              <>
                                <li><a onClick={this.TaskactiveBind.bind(this)}>My Task(s)</a></li>
                                <li><a onClick={this.TaskApprovalOneBind.bind(this)}>L-2 Approval</a></li>
                                <li><a onClick={this.TaskApprovalTwoBind.bind(this)}>L-3 Approval</a></li>
                              </>
                            }
                            {this.state.role_id == "300" ? <li><a onClick={this.CompletedTaskListbind.bind(this)}  >Task Answers</a></li> : null}
                            {this.state.role_id == "300" || this.state.role_id == "508" ? <li><a onClick={this.templates.bind(this)}>Templates</a></li> : null}

                            {this.state.role_id == "506" || this.state.role_id == "505" || this.state.role_id == "501" || this.state.role_id == "300" ?
                              <li> <a onClick={this.archive.bind(this)}><span>Archive List</span> </a> </li>
                              : null}
                            {this.state.role_id == "506" || this.state.role_id == "505" || this.state.role_id == "501" || this.state.role_id == "300" ?
                              <li> <a onClick={this.EquipmentList.bind(this)}><span>Equipment List</span> </a> </li> : ''}
                          </ul>
                        </div>

                        : null}

                        
                        
                    </li>
                    {this.state.role_id == "300" || this.state.role_id == "505" || this.state.role_id == "501" || this.state.role_id == "508" 
                    //  || this.state.role_id == "507"|| this.state.role_id == "510"|| this.state.role_id == "511"|| this.state.role_id == "504"|| this.state.role_id == "506"
                      ?
                      <li className="sub-menu" onClick={this.showTaskReportHandler.bind(this)}><a href="javascript:;" ><i className="fa fa-tasks"></i>
                        <span>Reports</span> </a>
                        {this.state.Taskreport ?
                          <div>
                            <ul class="sub" >
                              <li> {this.state.role_id !== "507" && this.state.role_id !== "510"&& this.state.role_id !== "511" && this.state.role_id !== "504"  && this.state.role_id !== "506"? <a onClick={this.Reportsbind.bind(this)}><span>General Reports</span> </a>:<></> }  </li>
                              {this.state.role_id == "300" || this.state.role_id == "501"
                              //  || this.state.role_id == "507"|| this.state.role_id == "510"|| this.state.role_id == "511"|| this.state.role_id == "504"|| this.state.role_id == "508"|| this.state.role_id == "506"|| this.state.role_id == "505"
                               ? <li> <a onClick={this.summaryReports.bind(this)}><span>Summary Reports</span> </a> </li> : ''}
                            </ul>
                          </div> : null}
                      </li>
                      : null}
                    {this.state.role_id == "300" || this.state.role_id == "501" || this.state.role_id == "508" ?
                      <li className="sub-menu" onClick={this.showTaskdwnHandler.bind(this)}> <a href="javascript:;" > <i className="fa fa-tasks"></i> <span>Utilities</span> </a>
                        {this.state.Taskdwn ?
                          <div>
                            <ul class="sub" >
                              {this.state.role_id == "300" ? <li> <a onClick={this.tiker.bind(this)}><span>Tiker Creation</span> </a> </li> : ''}
                              {this.state.role_id == "300" ? <li> <a onClick={this.usercreation.bind(this)}><span>Category Creation</span> </a> </li> : ''}
                              <li> <a onClick={this.userlist.bind(this)}><span>User List</span> </a> </li>

                            </ul>
                          </div> : null}
                      </li> : null}
                  </ul> : null}
                  {/* <button  onClick={this.handleDownloaddd}>Download</button>  */}
              </div>            
            </aside>     
                
            <section id="main-content">
              <section className="wrapper">
                <div className="mt">
                  {this.state.role_id == "300" ?
                    <h3><i className="fa fa-angle-right"></i>Active Task(s)

                      <a className="pull-right btn btn-theme" onClick={this.getroles.bind(this)}>+ Create Task</a>
                    </h3>
                    :
                    <h3><i className="fa fa-angle-right"></i>My Active Task(s)
                    </h3>
                  }
                  <hr />
                  <div className="row mt">
                    <div className="col-md-12">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3"> <b>Task ID</b><br />
                          <input type="number" placeholder="Search Task ID" className="form-control" id="taskname" onChange={this.onChange1} autoComplete="off" />
                        </div>

                        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3"> <b>Task Name</b><br />
                          <input type="text" placeholder="Search Task Name" className="form-control" id="taskdesc" onChange={this.onChange} autoComplete="off" />
                        </div>

                        <div className="col-xs-12 col-sm-3 col-md-2 col-lg-2 mt-xs-10 w-sm-110"> <b>Start Date</b><br />
                          <DatePicker autoComplete="off" className="form-control form-control-inline input-medium default-date-picker"
                            size="16" type="text" placeholderText="Select Start Date " dateFormat="dd-MMM-yyyy" id="startDate"
                            selected={this.state.startDate}
                            onChange={this.handleChangeStart}
                            onChangeRaw={this.handleDateChangeRaws}
                          />

                        </div>
                        <div className="col-xs-12 col-sm-3 col-md-2 col-lg-2 mt-xs-10 w-sm-110"><b> End Date</b><br />
                          <DatePicker autoComplete="off" className="form-control form-control-inline input-medium default-date-picker"
                            size="16" type="text" placeholderText="Select End Date" dateFormat="dd-MMM-yyyy" id="endDate"
                            selected={this.state.endDate}
                            onChange={this.handleChangeEnd}
                            onChangeRaw={this.handleDateChangeRawe}
                          />
                        </div>
                        <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1 mt-xs-10">
                          <img src={require("./img/searchicon.png")} className="user-img mt-20" style={{ width: "25px", height: "25px" }} />
                          
                        </div>   

                        <div className="clearfix">

                          
                        </div>
                      </div>


                      {/* <div> 
            <input type="file" onChange={this.handleFileChange}/>
            {previewImage && (
                <img src ={previewImage} alt="Preview" style={{width:'200px'}}/>
            )}
            {uploadSuccess && <p> Image uploaded successfully!</p>}
            {uploadError && <p>{uploadError}</p>}
            <button onClick={this.handleUpload}>Upload</button>
        </div> */}
                         
                      <div className="col-lg-10 col-md-10 col-sm-10 col-xs-12 tbwdth">
                        <div className="mt">

                          <div className="tbl-holder">

                            <div className="spin">
                              <Spinner visible={this.state.loading}
                                spinnerColor={"rgba(0, 0, 0, 0.3)"} />
                            </div>

                            <table className="table table-striped table-advance table-hover table-bordered tbl-task tbl-hhide">

                              <thead>

                                <tr>
                                  <th>Task ID</th>
                                  <th>Task Category</th>
                                  <th>Task Name</th>
                                  <th>Start Date</th>
                                  <th>End Date</th>
                                  {that.state.role_id == "300" ?
                                    <th>Action</th> : null}
                                </tr>
                              </thead>
                            </table>

                            <Scrollbars style={{ height: 296 }}>

                              <table className="table table-striped table-advance table-hover table-bordered tbl-task mob-tbl">
                                <tbody>


                                  {this.state.data.map(function (item, key) {

                                    if ((Search !== "" || (searchSDate) !== "" || (searchedDate) !== "" || (searcheddesc) !== "") &&
                                      (item.taskName.toLowerCase().indexOf(Search.toLowerCase()) || item.taskId.toLowerCase().indexOf(searcheddesc.toLowerCase()) ||
                                        item.startDate.toLowerCase().indexOf(searchSDate.toLowerCase()) ||
                                        item.endDate.toLowerCase().indexOf(searchedDate.toLowerCase())) === -1) {
                                      return null
                                    }

                                    return (

                                      <tr key={key}>
                                        {that.props.location.state.role_id == "300" ?
                                          <td data-th="Task Id"><a href="javascript:void(0)" onClick={that.calladdquestionpage.bind(that, item.taskId, item.taskName, item.taskDescription, item.startDate, item.endDate, item.publishStatus)} className="black-text" > {item.taskId}</a></td>

                                          :
                                          <td data-th="Task Id"><a href="javascript:void(0)" onClick={that.storepreviewpage.bind(that, item.taskId, item.taskName, item.taskDescription, item.startDate, item.endDate, item.status, item.storeNo, item.categoryId, item.categoryName)} className="black-text" > {item.taskId}</a></td>
                                        }

                                        {that.props.location.state.role_id == "506" ?
                                          <td data-th="Task Id"><a href="javascript:void(0)" onClick={that.previewpage.bind(that, item.taskId, item.taskName, item.taskDescription, item.startDate, item.endDate, item.technicianStatus, item.storeNo, item.technicianId, item.storeManagerStatus, item.afmStatus, item.categoryId, item.categoryName, item.zonalStatus)} className="black-text" > {item.taskId}</a></td>

                                          :
                                          null
                                        }
                                        <td data-th="Category">{item.categoryName}</td>
                                        <td data-th="Task Name">{item.taskName}</td>

                                        <td data-th="Start Date">{item.startDate}</td>
                                        <td data-th="End Date">{item.endDate}</td>
                                        {that.props.location.state.role_id == "300" ?
                                          <td data-th="Action">

                                            <a className="edit-icon"
                                              onClick={that.callupdatetaskpage.bind(that, item.taskId, item.taskName, item.taskDescription, item.startDate, item.endDate, item.taskRoleId)}> <i className="fa fa-pencil "></i> </a>

                                            <a className="delete-icon" onClick={that.deletetask.bind(that, item.taskId)}> <i className="fa fa-trash-o "></i> </a>
                                            <span className="d-none">{item.taskId}</span>
                                          </td>
                                          : null}

                                      </tr>
                                    )
                                  })}</tbody>

                              </table>
                            </Scrollbars>
                          </div>
                        </div>



  {/* <button  className="manual-upload-btn"onClick={this.toggleManualUploadOptions}>Manual Upload</button> */}
        
        {/* {showManualUploadOptions && (

          
          <div  className="options-menu">

           
            <>
            <label  style={{ marginRight: '20px' }}>
              <input class="custom-control-input" 
                type="radio" 
                value="DEEP CLEANING"
                checked={this.state.selectedOption === 'DEEP CLEANING'}
                //onChange={this.handleOptionChange}
                onClick={() => this.handleOptionClick('DEEP CLEANING')}
                // disabled={this.props.location.state.}
                disabled={that.props.location.state.role_id == '504' || that.props.location.state.role_id == '507' || that.props.location.state.role_id == '510' || that.props.location.state.role_id == '508' }
              />
              <span style={{ marginLeft: '5px',fontSize: '14px'  }}>Deep Cleaning</span>
            </label>
              <label>
              <input class="custom-control-input"
                type="radio" 
                value="CM"
                checked={this.state.selectedOption === 'CM'}
                //onChange={this.handleOptionChange}
                onClick={() => this.handleOptionClick('CM')}
                disabled={that.props.location.state.role_id == '511'|| that.props.location.state.role_id == '507' || that.props.location.state.role_id == '510'|| that.props.location.state.role_id == '508'}
              />
             <span style={{ marginLeft: '5px',fontSize: '14px'  }}>CM</span> 
            </label>
            <label style={{ marginLeft: '20px' }}>
              <input class="custom-control-input"
                type="radio"
                value="PM"
                checked={this.state.selectedOption === 'PM'}
               // onChange={this.handleOptionChange}
                onClick={() => this.handleOptionClick('PM')}
                disabled={that.props.location.state.role_id == '511'|| that.props.location.state.role_id == '507'  ||  that.props.location.state.role_id == '510' || that.props.location.state.role_id == '508' }
              />
            <span style={{ marginLeft: '2px',fontSize: '14px'  }}> PM</span>
            </label>
            <label style={{ marginLeft: '20px' }}>
              <input class="custom-control-input"
                type="radio"
                value="STORE AUDIT"
                checked={this.state.selectedOption === 'STORE AUDIT'}
                //onChange={this.handleOptionChange}
                onClick={() => this.handleOptionClick('STORE AUDIT')}
                disabled={that.props.location.state.role_id == '511'|| that.props.location.state.role_id == '504' || that.props.location.state.role_id == '507'||that.props.location.state.role_id == '510'|| that.props.location.state.role_id == '508' }
              />
            <span style={{marginLeft: '5px',fontSize: '14px' }} >Store Audit</span> 
            </label>
            <label style={{ marginLeft: '20px' }}>
              <input class="custom-control-input"
                type="radio"
                value="WORK PERMIT"
                checked={this.state.selectedOption === 'WORK PERMIT'}
                //onChange={this.handleOptionChange}
                onClick={() => this.handleOptionClick('WORK PERMIT')}
                disabled={that.props.location.state.role_id == '511' || that.props.location.state.role_id == '507'||that.props.location.state.role_id == '505'||that.props.location.state.role_id == '510' || that.props.location.state.role_id == '508' }
              />
             <span style ={{marginLeft: '5px',fontSize: '14px' }} >Permit To Work</span>
            </label>
           
            <label style={{ marginLeft: '20px' }}>
              <input class="custom-control-input"
                type="radio"
                value="ENERGY AUDIT"
                checked={this.state.selectedOption === 'ENERGY AUDIT'}
                //onChange={this.handleOptionChange}
                onClick={() => this.handleOptionClick('ENERGY AUDIT')} 
                disabled={that.props.location.state.role_id == '511' || that.props.location.state.role_id == '504'|| that.props.location.state.role_id == '505'|| that.props.location.state.role_id == '510'||  that.props.location.state.role_id == '506'|| that.props.location.state.role_id == '508'}          
              />
              <span style = {{marginLeft: '5px',fontSize: '14px' }}>Energy Audit</span>
            </label>
          
            <label style={{ marginLeft: '20px' }}>
              <input class="custom-control-input"
                type="radio"
                value="PEST CONTROL"
                checked={this.state.selectedOption === 'PEST CONTROL'}
               disabled={that.props.location.state.role_id == '511'||that.props.location.state.role_id == '504'|| that.props.location.state.role_id == '507' ||that.props.location.state.role_id == '508'  }
                //onChange={this.handleOptionChange}
                onClick={() => this.handleOptionClick('PEST CONTROL')}
              />
             <span style={{marginLeft: '3px',fontSize: '14px' }}> Pest Control</span>
              
            </label>

            <label style={{ marginLeft: '20px' }}>
              <input class="custom-control-input"
                type="radio"
                value="STORE CONNECT"
                checked={this.state.selectedOption === 'STORE CONNECT'}
               disabled={that.props.location.state.role_id == '511'||that.props.location.state.role_id == '510'|| that.props.location.state.role_id == '504'|| that.props.location.state.role_id == '505'|| that.props.location.state.role_id == '507'}
                //onChange={this.handleOptionChange}
                onClick={() => this.handleOptionClick('STORE CONNECT')}
              />
              <span style={{marginLeft: '5px',fontSize: '14px' }}>Store Connect</span>
              
            </label>
            </>
    
          </div>         
        )} */}
  
        {/* {showFileInput && (
          
                      <div className="file-input-container"> 
            <input type="file"  style={{ marginLeft:'80px'}}onChange={this.handleFileChange}  accept=".png,.jpeg,.jpg,.pdf"/>
             <div className="image-preview">
                                    {this.state.selectedOption === 'CM' && cmPreview && (
                                      <img src={cmPreview} alt="CM Preview" />
                                    )}
                                    {this.state.selectedOption === 'PM' && pmPreview && (
                                      <img src={pmPreview} alt="PM Preview" />
                                    )}
                                     {this.state.selectedOption === 'STORE AUDIT' && auditPreview && (
                                      <img src={auditPreview} alt="STORE AUDIT" />
                                    )}
                                     {this.state.selectedOption === 'WORK PERMIT' && permitWorkPreview && (
                                      <img src={permitWorkPreview} alt="WORK PERMIT" />
                                    )}
                                     {this.state.selectedOption === 'ENERGY AUDIT' && energyAuditPreview && (
                                      <img src={energyAuditPreview} alt="ENERGY AUDIT" />
                                    )}
                                    {this.state.selectedOption === 'DEEP CLEANING' && deepCleaningPreview && (
                                      <img src={deepCleaningPreview} alt="DEEP CLEANING" />
                                    )}
                                      {this.state.selectedOption === 'PEST CONTROL' && pestControlPreview && (
                                      <img src={pestControlPreview} alt="PEST CONTROL" style={{width:'100%',height:'auto'}}/>
                                    )}
                                    {this.state.selectedOption === 'STORE CONNECT' && storeConnectPreview && (
                                      <img src ={storeConnectPreview} alt="STORE CONNECT" />
                                    )}
                                  </div>
                                  <br/>
                   <div className="col-xs-12 col-sm-3 col-md-2 col-lg-2 mt-xs-10 w-sm-110">
                     <DatePicker
                      placeholderText="Select Date Of Uploading"
                      selected={this.state.startDatee}
                      onChange={this.handleDateChange}
                      className="form-control form-control-inline input-medium default-date-picker"
                      maxDate={new Date()}
                      minDate={new Date()}
                      dateFormat="dd-MMM-yyyy"                     
                    />
                    
                    </div>
            
            <button className="upload-btn" onClick={this.handleUpload}>Upload</button>

        </div>
        
              )}             */}
                      
                      </div>
                    </div>
                  </div>
                </div>

              </section>
            </section>
          </section>

        </div>
      );
    }
  }


  previewpage(taskId, taskName, taskDescription, startDate, endDate,
    publishStatus, storeNo, technicianId, storeManagerStatus, afmStatus, categoryId, categoryName, zonalStatus) {


      if (categoryId !== "4") {
        console.log(`hello 1a`)
        this.props.history.push({
          pathname: '/QuestionPreviewForCompletedTask',
          state: {
            tskId: taskId,
            tskName: taskName,
            tskDescr: taskDescription,
            strtDate: startDate,
            edDate: endDate,
            publishStatus: publishStatus,
            storeNo: this.props.location.state.storeNo,
            role_id: this.props.location.state.role_id,
            technicianId: technicianId,
            userid: this.props.location.state.userid,
            usrnm: this.props.location.state.usrnm,
            storeManagerStatus: storeManagerStatus,
            afmStatus: afmStatus,
            guId: this.props.location.state.guId,
            categoryId: categoryId,
            categoryName: categoryName,
            zonalStatus: zonalStatus



          }
        }
        );
      }
      else {
        console.log(`hello 1b`)
        this.props.history.push({
          pathname: '/QuestionPreviewForEquipmentTask',
          state: {
            tskId: taskId,
            tskName: taskName,
            tskDescr: taskDescription,
            strtDate: startDate,
            edDate: endDate,
            publishStatus: publishStatus,
            storeNo: this.props.location.state.storeNo,
            role_id: this.props.location.state.role_id,
            technicianId: technicianId,
            userid: this.props.location.state.userid,
            usrnm: this.props.location.state.usrnm,
            storeManagerStatus: storeManagerStatus,
            afmStatus: afmStatus,
            guId: this.props.location.state.guId,
            categoryId: categoryId,
            categoryName: categoryName,
            zonalStatus: zonalStatus



          }
        }
        );


      }
  }


  GetTasksOnload(e) {



    this.setState({ loading: true })


    if (this.props.location.state !== undefined && this.props.location.state.usrnm !== '') {
      this.setState({ usrnm: this.props.location.state.usrnm });
      this.setState({ userid: this.props.location.state.userid });
      this.setState({ tskId: this.props.location.state.tskId });
      this.setState({ tskName: this.props.location.state.tskName });
      this.setState({
        userid: this.props.location.state.userid,
        role_id: this.props.location.state.role_id
      })
      this.setState({ guId: this.props.location.state.guId })

      if (this.props.location.state.role_id !== "300") {
        var Request1 = {
          "userId": this.props.location.state.userid,
          "roleId": this.props.location.state.role_id,
          "levelNo": "1",
          "guId": this.props.location.state.guId,
        }





        










        var EncryptedRequest1 = Encrypt(Request1);
        console.log(EncryptedRequest1)

        fetchApi(appConfig.apiBaseUrl_Task + '/GetLevel1TaskList', {
          method: 'POST',
         // body: EncryptedRequest1,
          headers: {
            guId: this.props.location.state.guId,
            'Authorization': 'Basic ' + basicAuth(this.props.location.state.userid),
          },
          body: Request1
          })
          // .then((response) => response.text())
          // .then((response) => {
          //   var DecryptedResponse1 = decryptData(response)
          .then((result) => {
                        
            var DecryptedResponse1 = result.data;
            if (DecryptedResponse1.responseCode === '200 OK') {

              if (DecryptedResponse1.level1tasklist != undefined) {
                this.setState({ data: DecryptedResponse1.level1tasklist });
              }
              else {
                this.setState({ loading: false })
                showSuccess("No Task found")

              }



              var tickerdata = []
              if (DecryptedResponse1.tickerTextList != undefined) {
                for (let t = 0; t < DecryptedResponse1.tickerTextList.length; t++) {
                  if (DecryptedResponse1.tickerTextList[t].tickerText != " ") {
                    tickerdata.push(DecryptedResponse1.tickerTextList[t].tickerText + " || ")
                  }
                }
              }



              this.setState({ tickerList: tickerdata });

              this.setState({ loading: false })

            }
            else {
              this.setState({ loading: false })
              showSuccess(DecryptedResponse1.responseMsg)

            }
          })
          .catch((error) => {
            confirmAlert({
              title: 'Alert !',
              message: "Session expired",
              buttons: [
                {
                  label: 'Ok',
                  onClick: () => { this.logoutnormal() }
                },

              ]

            });
          });

      }

      else {
        // Prepare query parameters for GetTaskList
        const queryParams = { "function": "Task" };
        const queryString = new URLSearchParams(queryParams).toString();
        const urlWithParams = appConfig.apiBaseUrl_Task + `/GetTaskList?${queryString}`;
        
        // Generate checksum from query parameters for GET request
        const checksumKey = this.props.location.state.guId;
        const queryParamsString = JSON.stringify(queryParams);
        const requestChecksum = generateChecksumWithKeyNew(queryParamsString, checksumKey);
                
        // Use fetchApi with checksum validation for GetTaskList
        fetchApi(urlWithParams, {
          method: 'GET',
          headers: {
            guId: this.props.location.state.guId,
            'Authorization': 'Basic ' + basicAuth(this.props.location.state.userid),
            'checksum': requestChecksum  // Add checksum header
          }
        })
           .then((result) => {
                        
             var DecryptedResponse1 = result.data; 
            if (DecryptedResponse1.responseCode === '200 OK') {
              this.setState({ data: DecryptedResponse1.tasklist });
              this.setState({ loading: false })

            }
            else {
              this.setState({ loading: false })
              
              // Check if responseMsg contains "Invalid Function" or "InvalidFunction"
              const responseMsg = DecryptedResponse1.responseMsg || '';
              const isInvalidFunction = responseMsg.toLowerCase().includes('invalid function') || 
                                       responseMsg.toLowerCase().includes('invalidfunction');
              
              if (isInvalidFunction) {
                confirmAlert({
                  title: 'Invalid Function',
                  message: responseMsg,
                  buttons: [
                    {
                      label: 'Ok',
                      onClick: () => { this.logoutnormal() }
                    }
                  ]
                });
              } else {
                showSuccess(responseMsg)
              }
            }
          })
          .catch((error) => {
            console.error('========== [GetTaskList API] Error Details ==========');
            console.error('[GetTaskList] Error:', error);
            console.error('[GetTaskList] Error Message:', error.message);
            console.error('========================================================');
            
            confirmAlert({
              title: 'Alert !',
              message: "Session expired",
              buttons: [
                {
                  label: 'Ok',
                  onClick: () => { this.logoutnormal() }
                },

              ]


            });

          });

      }

    }
    else {
      this.props.history.push({
        pathname: '/',
      });
    }
  }




  deletetask(tskid) {

    confirmAlert({
      message: 'Are you sure, you want to delete this task?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            var Request2 = {
              "taskId": tskid,
              "createdBy": this.props.location.state.userid,
              "action": "Delete",
              "guId": this.props.location.state.guId,
            }
            var EncryptedRequest2 = Encrypt(Request2);
            fetchApi(appConfig.apiBaseUrl_Task + '/TaskDelete', {
              method: 'POST',
             // body: EncryptedRequest2,
              headers: {
                guId: this.props.location.state.guId,
                'Authorization': 'Basic ' + basicAuth(this.props.location.state.userid),
              },
              body: Request2
            })
              // .then((response) => response.text())
              // .then((response) => {

              //   var DecryptedResponse2 = decryptData(response)
              .then((result) => {
                        
                var DecryptedResponse2 = result.data;
                if (DecryptedResponse2.responseCode === '200 OK') {
                  confirmAlert({
                    message: DecryptedResponse2.responseMsg,
                    buttons: [
                      {
                        label: 'Ok',
                        onClick: () => { window.location.reload(true) }
                      },

                    ]
                  })

                  this.forceUpdate();
                }
                else {
                  showAlert(DecryptedResponse2.responseMsg)

                }
              })
              .catch((error) => {
                confirmAlert({
                  title: 'Alert !',
                  message: "Session expired",
                  buttons: [
                    {
                      label: 'Ok',
                      onClick: () => { this.logoutnormal() }
                    },

                  ]


                });

              });
          }
        },
        {
          label: 'No',
          onClick: () => {
            return false;
          }
        }
      ]
    })

  }

  templates = () => {
    this.props.history.push({
      pathname: '/Templates',
      state: {
        userid: this.state.userid,
        usrnm: this.state.usrnm,
        role_id: this.props.location.state.role_id,
        guId: this.props.location.state.guId

      }
    }
    );
  }



  callupdatetaskpage(tskId, tskName, tskDescr, strtDate, edDate, taskRoleId) {
    this.props.history.push({
      pathname: '/Updatetasks',
      state: {
        tskId: tskId,
        tskName: tskName,
        tskDescr: tskDescr,
        strtDate: new Date(strtDate),
        edDate: new Date(edDate),
        userid: this.props.location.state.userid,
        role_id: this.props.location.state.role_id,
        usrnm: this.state.usrnm,
        taskRoleId: taskRoleId,
        guId: this.props.location.state.guId

      }
    }
    );

  }
  storepreviewpage(tskId, tskName, tskDescr, strtDate, edDate, publishStatus, storeNo, categoryId, categoryName) {
    this.props.history.push({
      pathname: '/TaskStoreList',
      state: {
        tskId: tskId,
        tskName: tskName,
        tskDescr: tskDescr,
        strtDate: strtDate,
        edDate: edDate,
        role_id: this.props.location.state.role_id,
        userid: this.props.location.state.userid,
        usrnm: this.props.location.state.usrnm,
        publishStatus: publishStatus,
        storeNo: storeNo,
        guId: this.props.location.state.guId,
        categoryId: categoryId,
        categoryName: categoryName,
        fromPage: "level1"
      }
    }
    );

  }



  calladdquestionpage(tskId, tskName, tskDescr, strtDate, edDate, publishStatus) {
    this.props.history.push({
      pathname: '/Addquestion',
      state: {
        tskId: tskId,
        tskName: tskName,
        tskDescr: tskDescr,
        strtDate: strtDate,
        edDate: edDate,
        role_id: this.props.location.state.role_id,
        userid: this.props.location.state.userid,
        usrnm: this.props.location.state.usrnm,
        storeNo: this.props.location.state.storeNo,
        publishStatus: publishStatus,
        guId: this.props.location.state.guId
      }
    }
    );

  }



  getroles(e) {
    this.props.history.push({
      pathname: '/Createtasks',
      state: {
        role_id: this.props.location.state.role_id,
        userid: this.props.location.state.userid,
        usrnm: this.props.location.state.usrnm,
        guId: this.props.location.state.guId
      }
    }
    );
  }
  tiker = () => {

    this.props.history.push({
      pathname: '/Tiker',
      state: {
        userid: this.state.userid,
        usrnm: this.state.usrnm,
        role_id: this.props.location.state.role_id,
        guId: this.props.location.state.guId
      }
    }
    );

  }


  usercreation = () => {
    this.props.history.push({
      pathname: '/CategoryCreation',
      state: {
        userid: this.state.userid,
        usrnm: this.state.usrnm,
        role_id: this.props.location.state.role_id,
        guId: this.props.location.state.guId

      }
    }
    );
  }


  TaskactiveBind = () => {
    this.props.history.push({
      pathname: '/Taskactive',
      state: {
        userid: this.props.location.state.userid,
        usrnm: this.state.usrnm,
        role_id: this.props.location.state.role_id,
        guId: this.props.location.state.guId

      }
    }
    );
  }

  TaskApprovalOneBind = () => {
    this.props.history.push({
      pathname: '/LevelTwoApproval',
      state: {
        userid: this.props.location.state.userid,
        usrnm: this.state.usrnm,
        role_id: this.props.location.state.role_id,
        guId: this.props.location.state.guId

      }
    }
    );
  }

  TaskApprovalTwoBind = () => {
    this.props.history.push({
      pathname: '/LevelThreeApproval',
      state: {
        userid: this.props.location.state.userid,
        usrnm: this.state.usrnm,
        role_id: this.props.location.state.role_id,
        guId: this.props.location.state.guId

      }
    }
    );
  }

  userlist = () => {
    this.props.history.push({
      pathname: '/UserList',
      state: {
        userid: this.props.location.state.userid,
        usrnm: this.state.usrnm,
        role_id: this.props.location.state.role_id,
        guId: this.props.location.state.guId

      }
    }
    );
  }

  EquipmentList = () => {
    if (this.state.role_id == "505" || this.state.role_id == "501" || this.state.role_id == "300") {
      this.props.history.push({
        pathname: '/Newstore',
        state: {
          userid: this.props.location.state.userid,
          usrnm: this.props.location.state.usrnm,
          role_id: this.props.location.state.role_id,
          storeNo: this.props.location.state.storeNo,
          guId: this.props.location.state.guId
        }
      }
      );
    }
    else {
      this.props.history.push({
        pathname: '/EquipmentList',
        state: {
          userid: this.props.location.state.userid,
          usrnm: this.props.location.state.usrnm,
          role_id: this.props.location.state.role_id,
          storeNo: this.props.location.state.storeNo,
          guId: this.props.location.state.guId
        }
      }
      );
    }

  }

  Changepasswordbind = () => {
    this.props.history.push({
      pathname: '/Changepassword',
      state: {
        userid: this.props.location.state.userid,
        usrnm: this.state.usrnm,
        role_id: this.props.location.state.role_id,
        guId: this.props.location.state.guId
      }
    }
    );
  }


  Reportsbind = () => {
    this.props.history.push({
      pathname: '/Reports',
      state: {
        userid: this.props.location.state.userid,
        usrnm: this.state.usrnm,
        role_id: this.props.location.state.role_id,
        data: this.state.data,
        tskId: this.state.tskId,
        tskName: this.state.tskName,
        guId: this.props.location.state.guId

      }
    }
    );
  }







  showTaskReportHandler = () => {
    this.setState({
      Taskreport: !(this.state.Taskreport)
    })
  }



  summaryReports = () => {
    this.props.history.push({
      pathname: '/TaskSummaryReport',
      state: {
        userid: this.props.location.state.userid,
        usrnm: this.state.usrnm,
        role_id: this.props.location.state.role_id,
        guId: this.props.location.state.guId,
        data: this.state.data,
        tskId: this.state.tskId,
        tskName: this.state.tskName,

      }
    }
    );
  }
  archive = () => {
    this.props.history.push({
      pathname: '/Archive',
      state: {
        userid: this.props.location.state.userid,
        usrnm: this.state.usrnm,
        role_id: this.props.location.state.role_id,
        data: this.state.data,
        tskId: this.state.tskId,
        tskName: this.state.tskName,
        storeNo: this.props.location.state.storeNo,
        guId: this.props.location.state.guId
        // technicianId:this.props.location.state.technicianId

      }
    }
    );
  }



 
/*InstructionHandler = async (e) => {
  try {
    let files = e.target.files;
    if (files[0].type == "image/gif"
      || files[0].type == "image/jpg"
      || files[0].type == "image/jpeg"
      || files[0].type == "image/png"
      || files[0].type == "application/msword"
      || files[0].type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      || files[0].type == "application/vnd.openxmlformats-officedocument.presentationml.presentation"
      || files[0].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      || files[0].type == "application/vnd.ms-excel"
      || files[0].type == "application/pdf"
      || files[0].type == "application/vnd.ms-powerpoint"
      || files[0].type == "text/plain"
    ) {
      var Request1 = {
        "startDate": document.getElementById("startDate").value,
        "endDate": document.getElementById("endDate").value,
        "createdBy": this.state.userid,
        "taskDesc": document.getElementById("taskDesc").value,
        "taskName": document.getElementById("taskName").value,
        "storeId": this.state.StoreList,
        "action": "Create",
        "roleId": [this.props.location.state.role_id],
         "taskFile": this.state.previewData

      }

      var EncryptedRequest1 = Encrypt(Request1);
      console.log("ïnst", EncryptedRequest1)
      await FormDataService.uploadFormData(files[0], EncryptedRequest1);

       this.setState({ previewData: e.target.result });
      this.setState({ instructionUpload: 'File Uploaded Successfully' });

      this.setState({ instructiondata: files });
    }
    else {
      this.setState({ instructionUpload: '' });
      confirmAlert({
        title: 'Alert !',
        message: "Unsupported File Format.",
        buttons: [
          {
            label: 'Ok',
            onClick: () => { this.setState({ instructionUpload: "" }); }
          },

        ]
      })
    }
  } catch (error) {
    console.error('Need to handle error', error);
  }


}*/





  CompletedTaskListbind = () => {
    this.props.history.push({
      pathname: '/CompletedTaskList',
      state: {
        data: this.state.data,
        userid: this.props.location.state.userid,
        usrnm: this.state.usrnm,
        role_id: this.props.location.state.role_id,
        storeNo: this.props.location.state.storeNo,
        guId: this.props.location.state.guId
      }
    }
    );
  }
}
export default withRouter(taskactive);

